import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcEmptyContent = _resolveComponent("NcEmptyContent")

  return (_openBlock(), _createBlock(_component_NcEmptyContent, {
    class: "empty-view",
    name: $props.name,
    description: $props.description
  }, {
    icon: _withCtx(() => [
      _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
    ]),
    _: 3
  }, 8, ["name", "description"]))
}